<template>
    <div>
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Salary Payslip Details
        </h5>
        <div>
          <feather-icon
            class="ml-1 cursor-pointer"
            icon="XIcon"
            size="16"
            @click="$emit('close')"
          />
        </div>
      </div>
  
      <b-row>
        <div class="offset-md-1 col-md-10 col-lg-10 mb-2 mt-2">
          <validation-observer ref="payslipValidationModal">
            <b-form @submit.prevent="$emit('submit')">
              <user-info-card
                :currency="defaultCurrency"
                :user-data="userData"
                :payslip="paySlipData"
              />
              
                    <day-counted-salary-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                    />
                    <basic-salary-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                    />

                    <over-time-salary-info
                      :currency="defaultCurrency"
                      :user="userData"
                      :payslip="paySlipData"
                      @append-policy-data="forwardAppendFormData('overtime_policy_id', $event)"
                      @append-remarks-data="forwardAppendFormData('overtime_remarks', $event)"
                      @append-isPolicy-data="forwardAppendFormData('overtime_is_policy', $event)"
                      @append-manual-data="forwardAppendFormData('overtime_manual_amount', $event)"
                    />

                    <project-commission-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      :user="userData"
                      @append-policy-data="forwardAppendFormData('project_commission_policy_id', $event)"
                      @append-milestone-data="forwardAppendFormData('milestone_id', $event)"
                      @append-remarks-data="forwardAppendFormData('project_commission_remarks', $event)"
                      @append-isPolicy-data="forwardAppendFormData('project_commission_is_policy', $event)"
                      @append-manual-data="forwardAppendFormData('project_commission_manual_amount', $event)"
                    />

                    <k-p-i-commission-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      @append-data="forwardAppendFormData('kpi_amount', $event)"
                    />

                    <festival-bonus-info
                      :currency="defaultCurrency"
                      :user="userData"
                      :payslip="paySlipData"
                      @append-data="forwardAppendFormData('festival_bonus_policies', $event)"
                    />

                    <unpaid-leave-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      @append-fine-data="forwardAppendFormData('unpaid_leave_fine_amount', $event)"
                      @append-remarks-data="forwardAppendFormData('unpaid_leave_remarks', $event)"
                      @append-isManual-data="forwardAppendFormData('unpaid_leave_is_manual', $event)"
                      @append-manual-data="forwardAppendFormData('unpaid_leave_manual_amount', $event)"
                    />

                    <extra-leave-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      @append-fine-data="forwardAppendFormData('extra_leave_fine_amount', $event)"
                      @append-remarks-data="forwardAppendFormData('extra_leave_remarks', $event)"
                      @append-isManual-data="forwardAppendFormData('extra_leave_is_manual', $event)"
                      @append-manual-data="forwardAppendFormData('extra_leave_manual_amount', $event)"
                    />

                    <others-fine
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      :userData="userData"
                      @append-data="forwardAppendFormData('fine_policies', $event)"
                    />

                    <late-fine-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      :userData="userData"
                      @append-policy-data="forwardAppendFormData('late_fine_policies_id', $event)"
                      @append-remarks-data="forwardAppendFormData('late_fine_remarks', $event)"
                      @append-isPolicy-data="forwardAppendFormData('late_fine_is_policy', $event)"
                      @append-manual-data="forwardAppendFormData('late_fine_manual_amount', $event)"
                    />

                    <meal-info
                      :currency="defaultCurrency"
                      :payslip="paySlipData"
                      @append-policy-data="forwardAppendFormData('meal_policy_id', $event)"
                      @append-remarks-data="forwardAppendFormData('meal_remarks', $event)"
                      @append-isPolicy-data="forwardAppendFormData('meal_is_policy', $event)"
                      @append-manual-data="forwardAppendFormData('meal_manual_amount', $event)"
                      @append-meal-data="forwardAppendFormData('meal_amount', $event)"
                    />

                    <Loan-info
                        :currency="defaultCurrency"
                      :payslip="paySlipData"
                    />

                    <insurance-info
                        :currency="defaultCurrency"
                      :payslip="paySlipData"
                    />

                    <provident-fund-info
                        :currency="defaultCurrency"
                      :payslip="paySlipData"
                    />

                    <income-tax-info
                        :currency="defaultCurrency"
                      :payslip="paySlipData"
                      @append-data="forwardAppendFormData('income_tax_amount', $event)"
                    />

              <b-row>
                <b-col cols="6">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    :disabled="isSubmitting || paySlipData?.status === 'finally_generated'"
                  >
                    <b-spinner
                      v-if="isSubmitting"
                      small
                    />
                    Save
                  </b-button>
  
                  <template v-if="isPayslipPdfGenerating">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      class="flex-shrink-0 ml-1"
                      variant="danger"
                      disabled
                    >
                      <b-spinner small />
                      <span v-if="paySlipData?.status !== 'finally_generated'">Generating ..</span>
                      <span v-else>Downloading</span>
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      variant="danger"
                      @click="$emit('download-pdf')"
                    >
                      <span v-if="paySlipData?.status !== 'finally_generated'">Finalize And Generate PDF</span>
                      <span v-else>Download Payslip</span>
                    </b-button>
                  </template>
                </b-col>
  
                <b-col cols="6">
                  <h2 class="text-capitalize text-right">
                    Total: {{ defaultCurrency }} {{ totalPayableAmount }}
                  </h2>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </div>
      </b-row>
    </div>
  </template>
  
  <script>

import {
  BCard,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BButton,
  BForm,
  BModal,
  BRow,
  BCol,
  BInputGroupAppend,
  BInputGroup,
  BSpinner,
  BFormDatepicker,
  BLink,
  BTable,
  BSidebar
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";

import UserCard from "@/layouts/components/UserCard.vue";
import UserSelect from "@/layouts/components/UserSelect.vue";
import UserInfoCard from '@/views/admin/payroll-management/payslip/policy/UserInfoCard.vue'
import OverTimeSalaryInfo from '@/views/admin/payroll-management/payslip/policy/OverTimeSalaryInfo.vue'
import BasicSalaryInfo from '@/views/admin/payroll-management/payslip/policy/BasicSalaryInfo.vue'
import DayCountedSalaryInfo from '@/views/admin/payroll-management/payslip/policy/DayCountedSalaryInfo.vue'
import ProjectCommissionInfo from '@/views/admin/payroll-management/payslip/policy/ProjectCommissionInfo.vue'
import KPICommissionInfo from '@/views/admin/payroll-management/payslip/policy/KPICommissionInfo.vue'
import FestivalBonusInfo from '@/views/admin/payroll-management/payslip/policy/FestivalBonusInfo.vue'
import UnpaidLeaveInfo from '@/views/admin/payroll-management/payslip/policy/UnpaidLeaveInfo.vue'
import OthersFine from '@/views/admin/payroll-management/payslip/policy/OthersFine.vue'
import LateFineInfo from '@/views/admin/payroll-management/payslip/policy/LateFineInfo.vue'
import MealInfo from '@/views/admin/payroll-management/payslip/policy/MealInfo.vue'
import InsuranceInfo from '@/views/admin/payroll-management/payslip/policy/InsuranceInfo.vue'
import ProvidentFundInfo from '@/views/admin/payroll-management/payslip/policy/ProvidentFundInfo.vue'
import IncomeTaxInfo from '@/views/admin/payroll-management/payslip/policy/IncomeTaxInfo.vue'
import ExtraLeaveInfo from '@/views/admin/payroll-management/payslip/policy/ExtraLeaveInfo.vue'
import LoanInfo from '@/views/admin/payroll-management/payslip/policy/LoanInfo.vue'
  export default {
    name: 'PayslipSidebarContent',
    props: {
        defaultCurrency: {
        type: String,
        default: ''
      },
      userData: {
        type: Object,
        default: () => ({})
      },
      paySlipData: {
        type: Object,
        default: () => ({})
      },
      isSubmitting: {
        type: Boolean,
        default: false
      },
      isPayslipPdfGenerating: {
        type: Boolean,
        default: false
      },
      totalPayableAmount: {
        type: Number,
        default: 0
      }
    },
    components: {
    UserCard,
    UserSelect,
    DayCountedSalaryInfo,
    IncomeTaxInfo,
    InsuranceInfo,
    ProvidentFundInfo,
    MealInfo,
    LoanInfo,
    LateFineInfo,
    OthersFine,
    UnpaidLeaveInfo,
    FestivalBonusInfo,
    KPICommissionInfo,
    ProjectCommissionInfo,
    BasicSalaryInfo,
    OverTimeSalaryInfo,
    UserInfoCard,
    ExtraLeaveInfo,

    BCard,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BButton,
    BForm,
    BModal,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    BSpinner,
    BFormDatepicker,
    BLink,
    BTable,
    BSidebar,


    ValidationProvider,
    ValidationObserver,
    },
    directives: {
        Ripple,
    },

    methods: {
        forwardAppendFormData(field, value) {
        this.$emit('append-form-data', field, value); // Emit event to the parent
        },
        async validateForm() {
        if (this.$refs.payslipValidationModal) {
            return this.$refs.payslipValidationModal.validate();
        }
        return false;
        },
        
        resetValidation() {
        if (this.$refs.payslipValidationModal) {
            this.$refs.payslipValidationModal.reset();
        }
        },
        
        setValidationErrors(errors) {
        if (this.$refs.payslipValidationModal) {
            this.$refs.payslipValidationModal.setErrors(errors);
        }
        }
    }
  }
  </script>